import { atom } from 'jotai'

/**
 * Atom storing Event or null.
 *
 * @type {import('jotai').PrimitiveAtom<import('~shared/types').Event | null>}
 */
export const eventAtom = atom(/** @type {import('~shared/types').Event | null} */ (null))
